import { Spin, message } from "antd";
import React, { useEffect, useState } from "react";
import { setLocalStorageItem } from "../../Utils";
import { PlaceBet } from "../../Screens/Aviator/AviatorEndpoints";
import { AviatorImages } from "../../ImageController/Index";
import { LazyLoadImage } from "react-lazy-load-image-component";

const BetOption = ({ isFlying, waitingTime }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [betAmount, setBetAmount] = useState(10);
  const [pageLoad, setPageLoad] = useState(false);
  const [betDone, setBetDone] = useState(false);
  const Content = ({ multiply, win }) => {
    return (
      <div className="flex w-[300px] bg-[#123405] rounded-full px-1 gap-x-2 justify-around items-center">
        <div className="text-[#6a7868] text-xs font-bold">
          <p>You have cashed</p>
          <p className="text-white text-lg">{multiply}X</p>
        </div>
        <div className="bg-[#4caa11] w-1/2 m-2 py-2 font-bold rounded-full text-white">
          <p className="text-[12px]">Win RS.</p>
          <p className="text-sm">{Number(win)?.toFixed(2)}</p>
        </div>
      </div>
    );
  };
  const handlePlace = (type) => {
    setPageLoad(true);
    PlaceBet({
      type: type,
      betAmount: betAmount,
      ...(type === "cashout" && {
        multiplyNumbers: Number(isFlying?.currentFlyRange ?? 0),
      }),
      gameId: waitingTime?.data?.gameId,
    })
      .then((res) => {
        if (res.success) {
          if (type === "cashout") {
            setLocalStorageItem("betDone", false);
            setBetDone(false);
            messageApi.open({
              type: "success",
              duration: 5,
              style: { borderRadius: 100 },
              content: (
                <Content
                  multiply={res?.data?.multiplyNumber}
                  win={res?.data?.winingAmount}
                />
              ),
              icon: <p></p>,
            });
          } else {
            setLocalStorageItem("betDone", true);
            setBetDone(true);
            // message.success(res.message, 3);
          }
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setPageLoad(false));
  };
  useEffect(() => {
    if (waitingTime?.data?.gameStage === "waiting") {
      setLocalStorageItem("betDone", false);
      setBetDone(false);
    }
  }, [waitingTime]);

  return (
    <>
      {contextHolder}
      <div className="bg-primary select-none rounded-md w-full">
        <div className="py-3">
          <div className="flex justify-center gap-2 w-1/2 m-auto items-center bg-[#141516] rounded-full">
            {["Bet"].map((i, index) => {
              return (
                <p
                  key={index}
                  // onClick={() => setSelected(i.id)}
                  className={`text-white text-sm p-1 mx-1 w-full cursor-pointer text-center ${
                    index === 0 ? "radient rounded-full" : ""
                  }`}
                >
                  {i}
                </p>
              );
            })}
          </div>
        </div>
        <div className=" p-4 ">
          <div className="flex justify-between w-full h-full items-center gap-3">
            <div className="w-3/4 h-full">
              <div className="flex justify-between  bg-[#020203] p-1 rounded-full text items-center">
                <LazyLoadImage
                  onClick={() => {
                    if (betAmount > 1) {
                      setBetAmount((prev) => prev - 1);
                    }
                  }}
                  className="w-5 cursor-pointer"
                  loading="lazy"
                  src={AviatorImages.Dec}
                  alt="dec"
                />
                <p className="text-white">{betAmount}</p>
                <LazyLoadImage
                  onClick={() => setBetAmount((prev) => prev + 1)}
                  loading="lazy"
                  className="w-5 cursor-pointer"
                  src={AviatorImages.Inc}
                  alt="dec"
                />
              </div>
              <div className="grid grid-cols-2 place-items-center mt-4 gap-2">
                {[10, 100, 500, 1000].map((i, index) => {
                  return (
                    <p
                      key={index}
                      onClick={() => setBetAmount(i)}
                      className="bg-[#141516] cursor-pointer hover:bg-black hover:text-white transition-all text-[#7D7E7E] rounded-full flex justify-center items-center text-sm py-1 w-[71px]"
                    >
                      {i}
                    </p>
                  );
                })}
              </div>
            </div>
            {!betDone ? (
              // || !getLocalStorageItem("betDone")
              <button
                onClick={() => handlePlace("bet")}
                disabled={waitingTime?.data?.gameStage === "play"}
                className={` ${
                  waitingTime?.data?.gameStage === "waiting"
                    ? "bg-[#28A909] cursor-pointer"
                    : "bg-[#8fe979] cursor-not-allowed"
                } text-2xl font-bold  h-[87px] rounded-2xl flex justify-center flex-col items-center text-white font-cairo w-full `}
              >
                <Spin spinning={pageLoad}>
                  <div>
                    <p>BET</p>
                    <p> {betAmount}.00 ₹</p>
                  </div>
                </Spin>
              </button>
            ) : (
              <button
                onClick={() => handlePlace("cashout")}
                disabled={waitingTime?.data?.gameStage === "waiting"}
                className={` ${
                  waitingTime?.data?.gameStage === "waiting"
                    ? "bg-yellow-400 cursor-not-allowed"
                    : "bg-yellow-600  cursor-pointer "
                } text-2xl font-bold  h-[87px] rounded-2xl flex justify-center flex-col items-center text-white font-cairo w-full `}
              >
                <Spin spinning={pageLoad}>
                  <div>
                    <p>CashOut</p>
                    <p>
                      {" "}
                      {Number(betAmount ?? 0) *
                        Number(isFlying?.currentFlyRange ?? 0).toFixed(2)}{" "}
                      ₹
                    </p>
                  </div>
                </Spin>
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BetOption;
